import { BaseModel, DBDoc } from "@fry/lib/store";
import { Apps } from "@fry/lib/organisations";
import { guid } from "@fry/lib/utils";


export enum ConnectionType {
  RISR_ASSESS = "risr-assess",
}

export interface DetailedConnectionType {
  id: ConnectionType;
  name: string;
  // not interested in apps_allowed.
}

export const connectionTypeNamesById: { [key: string]: string } = {
  [ConnectionType.RISR_ASSESS]: "risr/assess",
};

export enum ExamTypeEnum {
  LOFT_WRITTEN = 'loft_written',
  LOFT_OSCE = 'loft_osce',
  COHORT = 'cohort_written',
}

export const EXAM_TYPES_OPTIONS = [
  { id: ExamTypeEnum.LOFT_WRITTEN, name: 'Individual on demand written exam' },
  { id: ExamTypeEnum.LOFT_OSCE, name: 'Individual on demand oral exam' },
  { id: ExamTypeEnum.COHORT, name: 'Cohort scheduled written exam' }
];

export interface RisrAssessBlueprint {
    id: string;
    name: string;
}

export interface RisrAssessItemSet {
    id: string;
    name: string;
}

export enum RisrAssessExamStates {
  WAITING_FOR_CREATION = "waitingForCreation",
  CREATED = "created",
  PUSHED = "pushed",
  STARTED = "started",
  RESULTS_READY = "resultsReady",
  DELETED = "deleted",
  ERROR = "error",
}

export const RisrAssessExamStatesDisplayNames: Record<RisrAssessExamStates, string> = {
  [RisrAssessExamStates.WAITING_FOR_CREATION]: "Waiting for Creation",
  [RisrAssessExamStates.CREATED]: "Created",
  [RisrAssessExamStates.PUSHED]: "Pushed",
  [RisrAssessExamStates.STARTED]: "Started",
  [RisrAssessExamStates.RESULTS_READY]: "Results Ready",
  [RisrAssessExamStates.DELETED]: "Deleted",
  [RisrAssessExamStates.ERROR]: "Error",
};


export const RisrAssessActionDisplayNames: Record<string, string> = {
  "risr_assess_create_loft_exam": "creating LOFT Exam",
  "callback_error_exam_pushed": "creating the exam",
  "callback_error_advance_ready": "generating results",
  "callback_error_exam_changed": "changing the exam",
  "push": "Push",
  "start": "Start",
  "import": "Import",
  "delete": "Delete",
};


export interface RisrAssessError {
  reason: string;
  action: string;
}

export interface RisrAssessExam {
  connectionId: string;
  state: RisrAssessExamStates,

  id: string;
  title: string;
  sessionTitle: string;
  startDate: string;

  startDateTimeFieldId?: string;
  examinerEmailFieldId?: string;

  url?: string;
  username?: string;
  password?: string;

  importerTaskId?: string
  resultEventUrl?: string

  error?: RisrAssessError
  errorMessage?: string
}

export class Connection extends BaseModel {
  public organisation: string;
  public connectionType: string;

  // risr-assess
  public host: string = "";
  public publicKey: string = "";
  public secretKey: string = "";
  public userFieldId: string = "";
  public oauthState: string = "";
  public connectivityStatus: "ok" | "error" = "ok";

  constructor(doc: DBDoc) {
    super(doc);

    this.organisation = this.orig.organisation;
    this.connectionType = this.orig.connectionType;

    if (this.connectionType === ConnectionType.RISR_ASSESS) {
      this.host = this.orig.host;
      this.publicKey = this.orig.publicKey;
      this.userFieldId = this.orig.userFieldId;
      this.oauthState = this.orig.oauthState;
      this.connectivityStatus = this.orig.connectivityStatus;
    }
  }
}


export function getDefaultConnectionByType(connectionType: ConnectionType): Connection {
  let doc: DBDoc = {
    _id: guid(),
    connectionType: ConnectionType.RISR_ASSESS,
    appsAllowed: [Apps.RISR_APPLY],
  }
  if (connectionType === ConnectionType.RISR_ASSESS) {
    doc = {
      ...doc,
      host: "",
      publicKey: "",
      userFieldId: "",
    };
  }
  return new Connection(doc);
}

